import { Question } from 'app/models/questions/Question'
import { UntypedFormGroup } from '@angular/forms'
import { HeaderComponent } from 'app/modules/survey/survey-viewer/survey-question/types/header/header.component'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'

export class Header extends Question {

  keepInSurveyAnswers() {
    return false
  }

  applyMaxAnswers(surveyForm) {
    return this.limitAnswersAmount
  }

  fillFormWithDummyAnswer(surveyForm): void {}

  getDisplayComponent() {
    return new QuestionComponent(HeaderComponent, this)
  }

  buildQuestionFormGroup() {
    return new UntypedFormGroup({})
  }

  buildFormGroupValidators() {
    return []
  }

  formatFormPayload(surveyForm: UntypedFormGroup): Record<string, {}> {
    return null
  }

}
